<!--
A heatmap that displays three layers of data for a specific geo, an optional service type group and a service type.
-->

<script>
import Heatmap from '@/components/heatmap/Heatmap.vue'
import GeoHeatmapLayer from './GeoHeatmapLayer'
import { eventBus } from '@/utils'

export default {
  extends: Heatmap,

  methods: {
    createHeatmapLayers () {
      return [
        {id: 'u', name: 'Customers', service: `/g_api/users`}
      ].map(cfg => {
        return new GeoHeatmapLayer(Object.assign(cfg, {
          lMap: this.lMap,
          heatmap: this,
          bus: eventBus('geo'),
          geoType: this.config.geoType,
          $store: this.$store
        }))
      })
    },

    addInitialLayerToMap () {
      this.findLayerById('u').overlay.addTo(this.lMap)
    },

    getInitialBounds (onSuccess, onError) {
      try {
        onSuccess(this.$store.state.geo.initialBounds)
      } catch (e) {
        onError(e)
      }
    }
  },

  watch: {
    '$route.params' (to, from) {
      if (to.st !== from.st || to.stg !== from.stg) {
        this.refreshLayers()
      }
    }
  }
}
</script>

<style lang="stylus">
  @require "~styles/components/_heatmap";
</style>




// WEBPACK FOOTER //
// frontend/src/pages/Geo/components/GeoHeatmap.vue